"use strict";

function _slicedToArray(e, t) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _unsupportedIterableToArray(e, t) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(e, t) {
  if (e) {
    if ("string" == typeof e) return _arrayLikeToArray(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray(e, t) : void 0;
  }
}
function _arrayLikeToArray(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function _iterableToArrayLimit(e, t) {
  var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (null != r) {
    var n,
      o,
      a = [],
      l = !0,
      i = !1;
    try {
      for (r = r.call(e); !(l = (n = r.next()).done) && (a.push(n.value), !t || a.length !== t); l = !0);
    } catch (e) {
      i = !0, o = e;
    } finally {
      try {
        l || null == r.return || r.return();
      } finally {
        if (i) throw o;
      }
    }
    return a;
  }
}
function _arrayWithHoles(e) {
  if (Array.isArray(e)) return e;
}
var helper = require("./helper/sampleHelper.js"),
  GlobalConstantsVariables = require("./GlobalConstantsVariables"),
  CLASS_NAME = "Utility:";
function getRandomTokenLocal() {
  var e = new Uint8Array(12);
  console.log("crypto ", crypto), crypto.getRandomValues(e);
  for (var t = "", r = 0; r < e.length; ++r) t += e[r].toString(12);
  return t;
}
function getRandomTokenLocal2() {
  for (var e = "", t = "1abc2def3ghi4jkl5mno6pqr7stu8vwx9z", r = 6; r > 0; r--) e += t[Math.floor(Math.random() * t.length)];
  return e;
}
function getCurrentDateLocal(e) {
  var t = "";
  switch (e) {
    case "db_format":
      t = new Date().toISOString().slice(0, 19).replace("T", " ");
      break;
    default:
      t = new Date().toString();
  }
  return t;
}
function getFormattedAge(e) {
  var t = new Date(e),
    r = (new Date() - t) / 864e5,
    n = Math.floor(r / 365),
    o = 10 * Math.round(n / 10);
  return "".concat(o, " - ").concat(o + 5);
}
function deepCopyJson(e) {
  var t = JSON.stringify(e);
  return JSON.parse(t);
}
function getCoverageRounded(e) {
  return "string" == typeof e && (e = parseInt(e)), e <= 999 ? 1e3 * e : e > 999 && e <= 1499 ? 1e6 : e >= 1500 && e < 1749 ? 15e5 : e > 1750 && e < 2001 ? 2e6 : e > 1e5 ? e : void 0;
}
function getCoverageArrayRounded(e) {
  for (var t = [], r = 0; r < e.length; r += 1) t.push(getCoverageRounded(e[r]));
  return t;
}
function jsonifyAddressesLocal(e) {
  var t = {};
  if (null != e) {
    var r = e.replace(/_-_-_/g, '"').replace(/\n/g, " ");
    t = JSON.parse(r);
  }
  return t;
}
function stringifyAddressesLocal(e) {
  return (e = JSON.stringify(e)).replace(/"/g, "_-_-_");
}
function _getAbsoluteFolderPath() {
  return console.log("process.cwd(): ".concat(process.cwd())), process.cwd().endsWith("server") ? "../../" : process.cwd().endsWith("src") ? "../" : "".concat(process.cwd(), "/");
}
module.exports = {
  randomNoGenerator: function (e, t) {
    return "number" != typeof t && "number" != typeof e && (e = 0, t = 1), Math.random() * (t - e) + e;
  },
  promptMessage: function () {
    console.log("This message is from NPM package: ", this.randomNoGenerator(2, 7)), console.log("Author from .env: ", process.env.AUTHOR);
    require("./../../../../state_average_cost_sqft.json");
    return console.log("Npm using link"), helper.helperMessage("Called from utility"), !0;
  },
  getFormattedAge: function (e) {
    var t = new Date("".concat(e, "-01-01")),
      r = (new Date() - t) / 864e5,
      n = Math.floor(r / 365),
      o = 10 * Math.round(n / 10);
    return "".concat(o, " - ").concat(o + 5);
  },
  getAgeFromBirthYear: function (e) {
    "string" == typeof e && (e = parseInt(e));
    var t = new Date("".concat(e, "-01-01")),
      r = (new Date() - t) / 864e5,
      n = Math.floor(r / 365);
    return isNaN(n) ? 30 : n;
  },
  getBirthYearFromAge: function (e) {
    return null == e ? null : new Date().getFullYear() - e;
  },
  getThousandsSeparatedStr: function (e) {
    var t = null;
    if (null == e) t = "";else if (null !== e.toString()) {
      var r = e.toString().split(".");
      r[0] = r[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","), t = "$".concat(r.join("."));
    } else t = e;
    return t;
  },
  isJsonReady4Persistence: function (e, t) {
    var r = ":isJsonReady4Persistence:",
      n = {};
    return null == e || e === {} ? console.log("Empty Input Leaving!", r, CLASS_NAME) : (Object.entries(e).forEach(function (e) {
      var o = _slicedToArray(e, 2),
        a = o[0],
        l = o[1];
      console.log("key: ", a, " # value: ", l, " # thisState[key]:", t[a], r, CLASS_NAME), ("id" === a || null != l && "0" !== l.toString() && l !== t[a]) && (n[a] = l);
    }), console.log("Input::outputJson: ", n, r, CLASS_NAME)), [Object.keys(n).length > 1, n];
  },
  stringifyAddresses: function (e) {
    return null == e || "" === e ? [] : stringifyAddressesLocal(e);
  },
  jsonifyAddresses: function (e) {
    return null == e || "" === e ? [] : jsonifyAddressesLocal(e);
  },
  separateDynamoCacheAttributes: function (e) {
    var t = ":separateDynamoCacheAttributes:",
      r = {},
      n = {},
      o = [];
    return console.log("inputJson: ", e, t, CLASS_NAME), Object.entries(e).forEach(function (t) {
      var n = _slicedToArray(t, 2),
        a = n[0],
        l = n[1];
      if (a.startsWith("address-") && !a.endsWith("-createdAt")) {
        r[a] = l;
        var i = null != e["".concat(a, "-createdAt")] ? e["".concat(a, "-createdAt")] : getCurrentDateLocal("db_format");
        o.push([{
          fullAddress: l,
          createdAt: i
        }]);
      }
    }), n.addresses = o, console.log("json4Dynanmo: ", n, t, CLASS_NAME), console.log("json4Cache: ", r, t, CLASS_NAME), [n, r];
  },
  getRandomToken: function () {
    return getRandomTokenLocal();
  },
  getRandomToken2: function () {
    return getRandomTokenLocal2();
  },
  getCurrentDate: function (e) {
    return getCurrentDateLocal(e);
  },
  getFormattedValue: function (e, t) {
    if (e === GlobalConstantsVariables.getPolicyTermLabel()) return t;
    if (e === GlobalConstantsVariables.getAgeLabel()) return "".concat(t, " Years");
    if (e === GlobalConstantsVariables.getPropertyLabel()) {
      if (t <= 999) return "$".concat(t, "K");
      if (t > 999 && t <= 1499) return "$1.00 M";
      if (t >= 1500 && t < 1749) return "$1.50 M";
      if (t > 1750 && t < 2001) return "$2.00 M";
    }
  },
  getFormattedNumberValue: function (e) {
    var t,
      r,
      n = [];
    if (null != e) {
      var o = "string" == typeof e ? Number(e) : e;
      o.toString().length > 6 ? (t = "M", o = ((o = o / 25e4 * 25e4) / 1e3).toFixed()) : t = "";
      var a = "".concat(o).split("").reverse(),
        l = a.length;
      n.push(t), a.forEach(function (e, t) {
        n.push(e), t % 3 == 2 && t < l - 1 && n.push(",");
      });
    } else n = [];
    return r = n.reverse().join(""), "M" === t && (r = (r = r.replace(",", ".")).replace("00M", "M")), r;
  },
  patchBrokenData1: function (e) {
    var t, r, n, o;
    return e.indexOf('"addresses') > -1 ? (r = (r = (t = e.split('":"[{'))[0]).replace('"addresses', ""), n = null != (t = e.split('"}]",'))[1] ? t[1] : "", o = "".concat(r).concat(n)) : o = e, o = (o = o.replace(/:null,/g, ':"",')).replace(/":null,"/g, "").replace(/"":/g, '":').replace(/,""/g, ',"');
  },
  getClientId: function () {
    var e,
      t = getRandomTokenLocal2();
    try {
      return null == chrome || null == chrome.storage || null == chrome.storage.local ? new Promise(function (e, r) {
        e(t);
      }) : new Promise(function (r, n) {
        chrome.storage.local.get("homecopilotuserid", function (n) {
          e = n.homecopilotuserid, console.log(e, "homecopilotuserid"), 0 === Object.keys(n).length && (e = t, chrome.storage.local.set({
            homecopilotuserid: e
          })), console.log(e, "clientId"), r(e);
        });
      });
    } catch (e) {
      console.log("Chrome is not defined");
    } finally {
      return new Promise(function (e, r) {
        e(t);
      });
    }
  },
  getQuoteId: function (e) {
    return e + "_" + getRandomTokenLocal2();
  },
  getApplicationId: function (e) {
    return e + "-" + getRandomTokenLocal2();
  },
  getPolicyId: function (e) {
    return e + "-" + getRandomTokenLocal2();
  },
  getAbsoluteFolderPath: function () {
    return _getAbsoluteFolderPath();
  },
  getKeyMapOrder4Mapping: function () {
    var e = "client_id,customer_id,email_id,firstname,lastname,status,paclife_quote_id,paclife_application_id,paclife_policy_id,sw_quote_id,sw_application_id,sw_policy_id,sbli_quote_id,sbli_application_id,sbli_policy_id,interest_type,status_date,dob,reference_id,ticket_id";
    return (e = e.replace(/ /g, "")).split(",");
  },
  getClientIdTimestamp: function (e) {
    return "".concat(e, "_").concat(Date.now());
  }
};